import { Tooltip, Button } from "@mui/material"
import { appdata } from "../internalModules"
import { appBarButtonStyle } from "../Graphics"
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined'
import { TrackAnalyticsEvent } from "../analytics/analytics"
import { LoadProjectEvent } from "../analytics/events"

type Props = {
  updateApp: Function,
  text?: string,
  variant?: 'outlined' | 'contained'
  color?: 'primary' | 'inherit'
  style?: {m: number, px: number}
}
  
export default function UIButtonLoadProject({updateApp, text, variant, color, style}: Props){
  const buttonText = text ? text : 'LOAD'
  const buttonStyle = style ? style : appBarButtonStyle

  function handleLoadFile(event: React.ChangeEvent) {
    const inputElement = event.target as HTMLInputElement
    if (inputElement.files) {
      const file = inputElement.files[0]
      const reader = new FileReader()
      reader.onload = loadJson
      reader.readAsText(file)
    }
  }

  function loadJson(e: ProgressEvent<FileReader>) {
    const jsonText = e?.target?.result as string
    if (jsonText && jsonText.length > 0) {
      appdata.readJsonFile(jsonText)
      TrackAnalyticsEvent(LoadProjectEvent)
      updateApp()
    }
    else {
      alert('Cannot read file.')
    }
  }
  
  return(
    <Tooltip arrow followCursor title='Load project from JSON file'>
      <Button variant={variant} color={color} sx={buttonStyle} component="label" startIcon={<FileUploadOutlinedIcon/>}>
        {buttonText}
        <input hidden accept=".json" type="file" onChange={handleLoadFile}/>
      </Button>
    </Tooltip>
  )
}